// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eexXFVGaw0zzoFuJIdm9{padding:12px;display:flex;gap:4px}`, "",{"version":3,"sources":["webpack://./src/widgets/AIAssistant/ui/AIAssistantContent/LoadingGeneration/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,YAAA,CACA,OAAA","sourcesContent":[".wrap{\n  padding: 12px;\n  display: flex;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `eexXFVGaw0zzoFuJIdm9`
};
export default ___CSS_LOADER_EXPORT___;
